import type { MenuSpec } from "./types";
import { ENABLE_TEMPLATE_REFERENCE } from "@kce2/feature_flags";

const helm3MenuItems = [
  {
    category: "helm3",
    id: "market",
    name: "应用市场",
    component: "helm3-market",
  },
  {
    category: "helm3",
    id: "releases",
    name: "应用管理",
    component: "helm3-releases",
  },
];

const allMenus = [
  {
    id: "cluster",
    name: "集群",
    component: "Cluster",
    index: true,
  },
  {
    id: "helm3",
    name: "Helm 3 应用",
    type: "title",
  },
  ...helm3MenuItems,
  {
    type: "divider",
    id: "helm3-divider",
  },
  {
    id: "prometheus",
    name: "Prometheus",
    extraLink: "//kce.console.ksyun.com/#/prometheus/index",
  },
  {
    id: "nt",
    name: "节点启动模板",
    component: "NodeTemplate",
  },
  {
    id: "rbac",
    name: "RBAC权限管理",
    component: "rbac",
  },
] as MenuSpec[];

// 根据 feature flag 过滤菜单
export const MENUS = Object.freeze(
  allMenus.filter(menu => {
    // 如果禁用模板引用功能，则隐藏"节点启动模板"菜单
    if (menu.id === "nt" && !ENABLE_TEMPLATE_REFERENCE) {
      return false;
    }
    return true;
  })
);

export const KCE2_ROLE_NAME = "KsyunKCEDefaultRole2.0";
export const KCE1_ROLE_NAME = "KsyunKCEDefaultRole";
export const KCE_ROLE_NAME = KCE2_ROLE_NAME;
